// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"599":"9c2efc5a","603":"97257821","637":"a2f5c288","848":"77ab775b","998":"77ab775b"}[chunkId] + ".chunk.css";
};